export default {
    highlight(text, searchTerm, styleObject) {
        if (!searchTerm) {
            return text;
        }

        return text.replace(new RegExp(searchTerm, 'gi'), match => {
            return `<span class="${styleObject['mds-combo-box--text-match']}">${match}</span>`;
        });
    },
};
